export default __webpack_public_path__ + "static/media/Collar of Endurance.ebad9372.jpg";